import { Box } from '@common-fe/common-fe';
import styled, { css } from 'styled-components';

import theme from '@/styles/theme';

interface StyledBoxProps {
  isHighlight?: boolean;
}

export const StyledBox = styled(Box)<StyledBoxProps>`
  ${({ isHighlight }) =>
    isHighlight
      ? css`
          animation-name: showHighlight;
          animation-duration: 3s;
          @keyframes showHighlight {
            from {
              border-color: ${theme.colors.accentActive};
              ${theme.shadows.highlighted};
            }
            to {
              border-color: transparent;
            }
          }
        `
      : ''}
`;
